import { createContext, useContext, useState, ReactNode } from 'react'
import Template from '@interfaces/template.interface'

interface TemplatesContextType {
  templates: Template[]
  setTemplates: (templates: Template[] | ((prev: Template[]) => Template[])) => void
}

const TemplatesContext = createContext<TemplatesContextType | undefined>(undefined)

export function TemplatesProvider({ children }: { children: ReactNode }) {
  const [templates, setTemplates] = useState<Template[]>([])

  return <TemplatesContext.Provider value={{ templates, setTemplates }}>{children}</TemplatesContext.Provider>
}

/**
 * Use the templates context
 * @returns The templates context
 */
export function useTemplates() {
  const context = useContext(TemplatesContext)
  if (context === undefined) {
    throw new Error('useTemplates must be used within a TemplatesProvider')
  }
  return context
}
